import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';
import { IPaymentMethod } from '@/models/paymentMethod.model';
import { PaymentMethodSwitch } from '../components';

export const getPaymentMethodsColumns = (
  t: TFunction,
  activePaymentMethodsCount: number,
): TableColumnsType<IPaymentMethod> => [
  {
    title: t('label_payment_provider'),
    dataIndex: 'code',
    key: 'code',
    render: (code: string) => code,
  },
  {
    title: t('label_status'),
    dataIndex: 'enabled',
    key: 'enabled',
    width: 160,
    render: (enabled: boolean, record) => (
      <PaymentMethodSwitch canDisable={activePaymentMethodsCount > 1} paymentMethodId={record.id} enabled={enabled} />
    ),
  },
];
